<template>
<div class="chapter">
<div class="inner_page">
<p class="epigraph"><a id="page_7"></a><a id="page_8"><strong><em>All sin is rooted in the failure of love.</em></strong></a></p><a id="page_8">
<p class="epigraph-author"><em>Thomas Merton</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Epigraph.vue?2c5a7237